import { render, staticRenderFns } from "./Kanban.vue?vue&type=template&id=766200ae&scoped=true"
import script from "./Kanban.vue?vue&type=script&lang=js"
export * from "./Kanban.vue?vue&type=script&lang=js"
import style0 from "./Kanban.vue?vue&type=style&index=0&id=766200ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766200ae",
  null
  
)

export default component.exports